// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface Arrange9To1IconSignature {
  Element: SVGSVGElement;
}

export const Arrange9To1Icon: TOC<Arrange9To1IconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 2H16C15.448 2 15 2.448 15 3V7C15 7.552 15.448 8 16 8H19V9H15V11H20C20.552 11 21 10.552 21 10V3C21 2.448 20.552 2 20 2ZM9 3V17.586L11.293 15.293L12.707 16.707L8 21.414L3.293 16.707L4.707 15.293L7 17.586V3H9ZM16 13H19C19.552 13 20 13.448 20 14V22H18V15H16V13ZM17 6H19V4H17V6Z"/>
</svg>
</template>;